import React, { useEffect, useState } from "react";
import { collection, onSnapshot, updateDoc, doc } from "firebase/firestore";
import { db } from "../utils/firebase";
import PromptCard from "./PromptCard";
import { useNavigate } from "react-router-dom";
import { AdminUserList } from "../Admin/AdminUserList";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useUser } from "../context/UserContext";
import AdminDashboard from "../Admin/AdminDashboard";

const ReviewPanel = () => {


     // State to hold pending prompts and stats
     const [pendingPrompts, setPendingPrompts] = useState([]);
     const [stats, setStats] = useState({
          totalPrompts: 0,
          pending: 0,
          success: 0,
     });

     // FETCH pending prompts
     useEffect(() => {
          const unsub = onSnapshot(collection(db, "prompts"), (snap) => {
               const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
               setPendingPrompts(list.filter((item) => item.status === "pending"));
          });

          return () => unsub();
     }, []);



     // HANDLE APPROVE
     const handleApprove = async (id) => {
          await updateDoc(doc(db, "prompts", id), {
               status: "success",
               approvedAt: new Date().toISOString(),
          });
     };


     // STATS — PROMPTS
     useEffect(() => {
          const unsubPrompts = onSnapshot(collection(db, "prompts"), (snap) => {
               const docs = snap.docs.map((d) => d.data());
               setStats((prev) => ({
                    ...prev,
                    totalPrompts: docs.length,
                    pending: docs.filter((d) => d.status === "pending").length,
                    success: docs.filter((d) => d.status === "success").length,
               }));
          });

          return () => unsubPrompts();
     }, []);



     const [isAuthorized, setIsAuthorized] = useState(null); // Loading state
     const navigate = useNavigate();

     useEffect(() => {
          const keyIDK = localStorage.getItem("userID");
          const blockedID = "sf6AgF7nFPWq3UymYdeOhiI2Bns2";

          if (keyIDK === blockedID) {
               setIsAuthorized(false);
               // Optional: Aap user ko redirect bhi kar sakte hain
               // navigate('/unauthorized'); 
          } else {
               setIsAuthorized(true);
          }
     }, [navigate]);


       const { userData } = useUser();

     // 1. Jab tak check ho raha hai (Prevents flickering)
     if (isAuthorized === null) {
          return <div className="loading">Checking access...</div>;
     }

     // 2. Agar ID match ho gayi (Blocked)
     if (!isAuthorized) {
          return (
               <div style={{ textAlign: 'center', marginTop: '50px', color: 'red' }}>
                    <h2>Access Denied</h2>
                    <p>You do not have permission to view this page.</p>
               </div>
          );
     }

     


     return (
          <div className="admin-review-panel">
               <div className="__container">
                    <h2>Pending Prompts for Review & Details</h2>
                    <p>Review and moderate user-submitted prompts below.</p>

                    <Tabs>
                         <TabList>
                              <Tab>Prompt Details</Tab>
                              <Tab>Subscriptions</Tab>
                              <Tab>credit tables</Tab>
                         </TabList>

                         <TabPanel>
                              <div className="row row-gap-3">

                                   <div className="col-12">
                                        <div className="admin-stats-card mt-4">
                                             <ul>
                                                  <li>Total Prompts: <strong>{stats?.totalPrompts || 0}</strong></li>
                                                  <li>Pending: <strong>{stats?.pending || 0}</strong></li>
                                                  <li>Approved: <strong>{stats?.success || 0}</strong></li>
                                             </ul>
                                        </div>
                                   </div>

                                   {pendingPrompts?.length === 0 && (
                                        <div className="col-12">
                                             <p className="text-center">No pending prompts right now.</p>
                                        </div>
                                   )}

                                   {pendingPrompts?.map((item) => (
                                        <PromptCard
                                             key={item.id}
                                             data={item}
                                             onApprove={() => handleApprove(item.id)}
                                        />
                                   ))}
                              </div>
                         </TabPanel>
                         <TabPanel>
                              <AdminUserList />
                         </TabPanel>

                         <TabPanel>
                              <AdminDashboard userData={userData}/>
                         </TabPanel>
                    </Tabs>



                   
               </div>



          </div>
     );
};

export default ReviewPanel;